import { API_SERVERLESS_ENDPOINT } from '../../app.config';

export const LOGIN_TYPE = 'LOGIN';
export const LOGOUT_TYPE = 'LOGOUT';

const def = 'default';
const time = 'time';
const param = 'param';
const post = 'post';
const createActionType = ({
  name,
  api,
  type,
  reducerType,
}: {
  name: string;
  api: string;
  type: string;
  reducerType: string | string[];
}) => {
  return {
    name: name,
    set: name + '_SET',
    clear: name + '_CLEAR',
    api: api,
    type: type ? type : name,
    reducerType: reducerType,
  };
};

// A
export const ACL_GROUP_LIST = createActionType({
  name: 'ACL_GROUP_LIST',
  api: `${API_SERVERLESS_ENDPOINT}/admin/acl-groups`,
  type: 'acl group',
  reducerType: def,
});
export const ACL_PERMISSION_LIST = createActionType({
  name: 'ACL_PERMISSION_LIST',
  api: `${API_SERVERLESS_ENDPOINT}/admin/acl-permissions`,
  type: 'acl permissions',
  reducerType: def,
});
export const ACL_USER_LIST = createActionType({
  name: 'ACL_USER_LIST',
  api: `${API_SERVERLESS_ENDPOINT}/admin/acl-users`,
  type: 'acl user',
  reducerType: def,
});
export const AUTOVIEW_LIST = createActionType({
  name: 'AUTOVIEW_LIST',
  api: `${API_SERVERLESS_ENDPOINT}/admin/autoviews`,
  type: 'autoview',
  reducerType: def,
});
// B
export const BADGE_LIST = createActionType({
  name: 'BADGE_LIST',
  api: `${API_SERVERLESS_ENDPOINT}/admin/badges`,
  type: 'badge',
  reducerType: def,
});
export const BANNER_LIST = createActionType({
  name: 'BANNER_LIST',
  api: `${API_SERVERLESS_ENDPOINT}/admin/banners`,
  type: 'banners',
  reducerType: def,
});
export const BANNER_SLIDER_LIST = createActionType({
  name: 'BANNER_SLIDER_LIST',
  api: `${API_SERVERLESS_ENDPOINT}/admin/banner-sliders`,
  type: 'banner sliders',
  reducerType: def,
});
// C
export const CATEGORY_LIST = createActionType({
  name: 'CATEGORY_LIST',
  api: `${API_SERVERLESS_ENDPOINT}/admin/category`,
  type: 'category',
  reducerType: def,
});
export const COLLECTION_LIST = createActionType({
  name: 'COLLECTION_LIST',
  api: `${API_SERVERLESS_ENDPOINT}/admin/collections`,
  type: 'collection',
  reducerType: time,
});
export const COLLECTION_TYPE_LIST = createActionType({
  name: 'COLLECTION_TYPE_LIST',
  api: `${API_SERVERLESS_ENDPOINT}/admin/collection-types`,
  type: 'collection type',
  reducerType: def,
});
export const COLLECTION_PHOTO_LIST = createActionType({
  name: 'COLLECTION_PHOTO_LIST',
  api: `${API_SERVERLESS_ENDPOINT}/admin/collection-photos`,
  type: 'Photo Collection',
  reducerType: time,
});

export const COMMENT_MEDIA = createActionType({
  name: 'COMMENT_MEDIA',
  api: `${API_SERVERLESS_ENDPOINT}/admin/comments`,
  type: 'Media Comment',
  reducerType: param,
});
export const COMMENT_USER = createActionType({
  name: 'COMMENT_USER',
  api: `${API_SERVERLESS_ENDPOINT}/admin/comments`,
  type: 'User Comment',
  reducerType: param,
});
export const CONTEST_LIST = createActionType({
  name: 'CONTEST_LIST',
  api: `${API_SERVERLESS_ENDPOINT}/admin/contests`,
  type: 'contest',
  reducerType: def,
});
export const CONTEST_TYPE_LIST = createActionType({
  name: 'CONTEST_TYPE_LIST',
  api: `${API_SERVERLESS_ENDPOINT}/admin/contest-types`,
  type: 'contest type',
  reducerType: def,
});
// D
// E
export const EDITORIAL_AUTHOR_LIST = createActionType({
  name: 'EDITORIAL_AUTHOR_LIST',
  api: `${API_SERVERLESS_ENDPOINT}/admin/editorial-authors`,
  type: 'editorial author',
  reducerType: def,
});
// F
export const FEATURE_BOX_LIST = createActionType({
  name: 'FEATURE_BOX_LIST',
  api: `${API_SERVERLESS_ENDPOINT}/admin/feature-boxes`,
  type: 'feature box',
  reducerType: def,
});
export const FEATURE_LOCATION_LIST = createActionType({
  name: 'FEATURE_LOCATION_LIST',
  api: `${API_SERVERLESS_ENDPOINT}/admin/feature-box-locations`,
  type: 'feature box location',
  reducerType: def,
});
// G
// H
// I
// J
// K
// L
// M
export const MEDIA_MENTION = createActionType({
  name: 'MEDIA_MENTION',
  api: `${API_SERVERLESS_ENDPOINT}/admin/media-mention`,
  type: 'Media Mention',
  reducerType: def,
});
export const MESSAGE_NOTIFICATION = createActionType({
  name: 'MESSAGE_NOTIFICATION',
  api: `${API_SERVERLESS_ENDPOINT}/admin/send-notification`,
  type: 'Message Notification',
  reducerType: def,
});
export const MESSAGE_NOTIFICATION_LIST = createActionType({
  name: 'MESSAGE_NOTIFICATION_LIST',
  api: `${API_SERVERLESS_ENDPOINT}/admin/message/notification`,
  type: 'Message Notification List',
  reducerType: def,
});
export const MRSS_CATEGORY_LIST = createActionType({
  name: 'MRSS_CATEGORY_LIST',
  api: `${API_SERVERLESS_ENDPOINT}/admin/mrss-category`,
  type: 'MRSS Media',
  reducerType: def,
});
export const MRSS_MEDIA_LIST = createActionType({
  name: 'MRSS_MEDIA_LIST',
  api: `${API_SERVERLESS_ENDPOINT}/admin/mrss-media`,
  type: 'MRSS Media',
  reducerType: def,
});
export const MRSS_LIST = createActionType({
  name: 'MRSS_LIST',
  api: `${API_SERVERLESS_ENDPOINT}/admin/mrss`,
  type: 'MRSS',
  reducerType: def,
});
export const MRSS_EIPSODES_LIST = createActionType({
  name: 'MRSS_EIPSODES_LIST',
  api: `${API_SERVERLESS_ENDPOINT}/admin/mrss-episodes`,
  type: 'MRSS Episodes',
  reducerType: def,
});
export const MRSS_SERIES_LIST = createActionType({
  name: 'MRSS_SERIES_LIST',
  api: `${API_SERVERLESS_ENDPOINT}/admin/mrss-series`,
  type: 'MRSS Series',
  reducerType: def,
});
// N
// O
// P
export const PARTNER_LIST = createActionType({
  name: 'PARTNER_LIST',
  api: `${API_SERVERLESS_ENDPOINT}/admin/partners`,
  type: 'partner',
  reducerType: def,
});

export const PARTNER_EXCLUSIVE_LIST = createActionType({
  name: 'PARTNER_EXCLUSIVE_LIST',
  api: `${API_SERVERLESS_ENDPOINT}/admin/partner-exclusives`,
  type: 'partner exclusive',
  reducerType: def,
});

export const PHOTO_LIST = createActionType({
  name: 'PHOTO_LIST',
  api: `${API_SERVERLESS_ENDPOINT}/admin/photos`,
  type: 'photo',
  reducerType: def,
});
// Q
// R
export const REPORT_AIRVUZ_MRSS = createActionType({
  name: 'REPORT_AIRVUZ_MRSS',
  api: `${API_SERVERLESS_ENDPOINT}/admin/report/airvuz-mrss`,
  type: 'AirVuz MRSS Report',
  reducerType: [post, param],
});
export const REPORT_CONTRIBUTOR = createActionType({
  name: 'REPORT_CONTRIBUTOR',
  api: `${API_SERVERLESS_ENDPOINT}/admin/report/contributor-stats`,
  type: 'Contributor Report',
  reducerType: param,
});
export const REPORT_HEAVILY_COMMENT_MEDIA = createActionType({
  name: 'REPORT_HEAVILY_COMMENT_MEDIA',
  api: `${API_SERVERLESS_ENDPOINT}/admin/report/heavily-comment-media`,
  type: 'Heavily Commented Media Report',
  reducerType: param,
});
export const REPORT_JUDGE_COLLECTION = createActionType({
  name: 'REPORT_JUDGE_COLLECTION',
  api: `${API_SERVERLESS_ENDPOINT}/admin/collections?isJudge=true`,
  type: 'Judge Collection List',
  reducerType: time,
});
export const REPORT_JUDGE = createActionType({
  name: 'REPORT_JUDGE',
  api: `${API_SERVERLESS_ENDPOINT}/admin/report/collection-judge-ratings`,
  type: 'Judge Detail Report',
  reducerType: [post, param],
});
export const REPORT_JUDGE_ONE = createActionType({
  name: 'REPORT_JUDGE_ONE',
  api: `${API_SERVERLESS_ENDPOINT}/admin/report/collection`, // /:id/judge-rating
  type: 'Judge One Report',
  reducerType: param,
});
export const REPORT_MISSING_CONTRIBUTOR = createActionType({
  name: 'REPORT_MISSING_CONTRIBUTOR',
  api: `${API_SERVERLESS_ENDPOINT}/admin/report/mia-content-creator`,
  type: 'Missing Contributor Report',
  reducerType: param,
});
// export const REPORT_NEW_PHOTO_CONTRIBUTOR = createActionType({
//     name: 'REPORT_NEW_PHOTO_CONTRIBUTOR',
//     api: `${API_SERVERLESS_ENDPOINT}/admin/report/new-contributor`,
//     type: 'New Contributor Report',
//     reducerType: param,
// })
export const REPORT_NEW_CONTRIBUTOR = createActionType({
  name: 'REPORT_NEW_VIDEO_CONTRIBUTOR',
  api: `${API_SERVERLESS_ENDPOINT}/admin/report/new-contributor`, //new-user?type=video
  type: 'New Contributor Report',
  reducerType: param,
});

export const REPORT_NEW_USER = createActionType({
  name: 'REPORT_NEW_USER',
  api: `${API_SERVERLESS_ENDPOINT}/admin/report/new-user`,
  type: 'New User Report',
  reducerType: param,
});
export const REPORT_SOCIAL_MEDIA_SHARE = createActionType({
  name: 'REPORT_SOCIAL_MEDIA_SHARE',
  api: `${API_SERVERLESS_ENDPOINT}/admin/report/media-share`,
  type: 'Social Media Share Report',
  reducerType: param,
});
export const REPORT_VIDEO_FEATURE_LIST = createActionType({
  name: 'REPORT_VIDEO_FEATURE_LIST',
  api: `${API_SERVERLESS_ENDPOINT}/admin/report/feature-worthy`,
  type: 'Feature Eligible Report',
  reducerType: param,
});
export const REPORT_UPLOADS = createActionType({
  name: 'REPORT UPLOADS',
  api: `${API_SERVERLESS_ENDPOINT}/admin/report/upload`,
  type: 'Uploads Report',
  reducerType: param,
});
// S
export const SITE_INFO = createActionType({
  name: 'SITE_INFO',
  api: `${API_SERVERLESS_ENDPOINT}/admin/report/site-info`,
  type: 'Site Info',
  reducerType: param,
});
export const SNACKBAR = createActionType({
  name: 'SNACKBAR',
  api: '',
  type: 'SnackBar',
  reducerType: '',
});
export const CONFIRMATION = createActionType({
  name: 'CONFIRMATION',
  api: '',
  type: 'Confirmation',
  reducerType: '',
});
// T
export const TOP_CONTRIBUTOR = createActionType({
  name: 'TOP_CONTRIBUTOR',
  api: `${API_SERVERLESS_ENDPOINT}/admin/top-users`,
  type: 'Top contributor',
  reducerType: def,
});
export const TV_LIST = createActionType({
  name: 'TV_LIST',
  api: `${API_SERVERLESS_ENDPOINT}/admin/tv/collection-types`,
  type: 'TV List',
  reducerType: def,
});
export const TV_FEATURE = createActionType({
  name: 'TV_FEATURE',
  api: `${API_SERVERLESS_ENDPOINT}/admin/tv/features`,
  type: 'TV Feature',
  reducerType: def,
});
// U
export const UPLOAD_LIST = createActionType({
  name: 'UPLOAD_LIST',
  api: `${API_SERVERLESS_ENDPOINT}/admin/upload`,
  type: 'upload',
  reducerType: time,
});
// V
export const VIDEO_LIST = createActionType({
  name: 'VIDEO_LIST',
  api: `${API_SERVERLESS_ENDPOINT}/admin/curation/videos`,
  type: 'Video',
  reducerType: time,
});
// W
// X
// Y
// Z
